import React, { HTMLAttributes } from 'react';
// Mini component to handle the errors in the form
interface Props {
	nameError: string | undefined, 
	touchedName?: string
}
const FormErrorContainer = ({ nameError, touchedName }: Props ): JSX.Element => {
	return (
		nameError && (
			<div className="formValidationError">{nameError}</div>
		) || <></>
	)
}

export default FormErrorContainer;
